import { useTransitionsEffect } from '../layouts/Transitions'

const Home = () => {
  useTransitionsEffect((setTransition) => setTransition('fade'), [])

  return <></>
}

export default Home
